import { z } from 'zod';
import { apiEnvelope, numericString, optionalDocument, optionalText, tonsToKg } from './backend.schema';

/**
 * Fila de `GET /seed-backoffice/traslado` (`ws_SemTabTraslado`); números como string y `Kg_Despachados` en toneladas.
 * El backend todavía no informa fecha ni bolsones: quedan `null`.
 */
export const TrasladoApiSchema = z
  .object({
    PLote_Codigo: z.string(),
    Nro_Turno: numericString,
    Kg_Despachados: numericString,
    Area_Destino_Des: optionalText,
    Transporte: optionalText,
    Chofer: optionalText,
    Patente_Chasis: optionalText,
    Patente_Acoplado: optionalText,
    Remito: optionalDocument,
    Kilos_Neto: numericString,
  })
  .transform((t) => ({
    lote: t.PLote_Codigo,
    turno: String(t.Nro_Turno),
    fecha: null as string | null,
    bolsones: null as number | null,
    kg: tonsToKg(t.Kg_Despachados),
    curadora: t.Area_Destino_Des,
    transportista: t.Transporte,
    chofer: t.Chofer,
    chasis: t.Patente_Chasis,
    acoplado: t.Patente_Acoplado,
    remito: t.Remito,
    neto: t.Kilos_Neto === 0 ? null : Math.round(t.Kilos_Neto),
  }));

/** `{ data: { items, Message } }`, o `{ data: { Message } }` sin filas. */
export const TrasladosRespSchema = apiEnvelope(z.object({ items: z.array(TrasladoApiSchema).optional() })).transform(
  (r) => r.data.items ?? [],
);

export type Traslado = z.output<typeof TrasladoApiSchema>;
